export const modalNames = {
  contactUs: 'contactUs',
}
